import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Box, Typography, Slider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import FederalLoan from './FederalLoan';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    marginBottom: theme.spacing(1),
  },
  summary: {
    background: theme.palette.background.default,
  },
  details: {
    border: '1px solid rgba(105, 109, 117, 0.15)',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
    }
  },
}));

const AidAndDebt = ({ school }) => {
  const classes = useStyles();

  const debtData =
    school['latest.programs.cip_4_digit']?.length > 1
      ? [
          minBy(school['latest.programs.cip_4_digit'], 'debt.median_debt')?.debt
            ?.median_debt,
          maxBy(school['latest.programs.cip_4_digit'], 'debt.median_debt')?.debt
            ?.median_debt,
        ]
      : null;

  const marks = debtData && [
    {
      value: debtData[0],
      label: debtData[0] ? `$${debtData[0]?.toLocaleString()}` : 'N/A',
    },
    {
      value: debtData[1],
      label: debtData[1] ? `$${debtData[1]?.toLocaleString()}` : 'N/A',
    },
  ];

  return (
    <div className={classes.root}>
      <Accordion elevation={0}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon />}
          IconButtonProps={{
            edge: 'start',
            color: 'inherit',
          }}
          className={classes.summary}
        >
          <Typography variant="body2">
            {'Financial Aid & Debt'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
            <FederalLoan cx={80} cy={100} school={school} />
          </Box>
          <Box display="flex" flexDirection="column" textAlign="center" marginTop={{ xs: 3, sm: 0 }}>
            {debtData ? (
              <>
                <Typography variant="subtitle1">
                  Median Total Debt After Graduation
                </Typography>
                <Box paddingBottom={4} paddingTop={{ xs: 3, sm: 4 }}>
                  <Slider
                    value={debtData}
                    marks={marks}
                    valueLabelDisplay="auto"
                    aria-labelledby="range-slider"
                    step={10000}
                    min={0}
                    max={(marks[1]?.value || 240000) + 10000}
                    disabled
                  />
                </Box>
              </>
            ) : (
              <>
                <Typography align="center" variant="subtitle1">
                  Median Total Debt After Graduation
                </Typography>
                <Typography align="center" variant="caption">
                  Data Not Available
                </Typography>
              </>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default AidAndDebt;
